import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { TabularSinkAdapter } from './tabular.sink.adapter';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';
import { ValueAdapter } from '../../value.adapter';
import { PostgreSqlV2Sink } from 'app/model/pipeline/copysink/postgre-sql-v2.copysink';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(PostgreSqlV2Sink),
    asynchronous: true,
    adapts: {
        type: '*',
        writeBatchTimeout: '*',
        writeBatchSize: '*',
        preCopyScript: '*',
        maxConcurrentConnections: '*',
        writeBehavior: '*'
    }
})
export class PostgreSqlV2SinkAdapter extends CopySinkAdapter<PostgreSqlV2Sink, Model.PostgreSqlV2Sink> {
    protected override async _toResource(model: PostgreSqlV2Sink): Promise<Model.PostgreSqlV2Sink> {
        const result: Model.PostgreSqlV2Sink = {
            type: 'PostgreSqlSink'
        };
        TabularSinkAdapter.toSinkResource(model, result);
        result.writeBehavior = ValueAdapter.toResource(model, PostgreSqlV2Sink.WRITE_BEHAVIOR);
        return result;
    }

    protected override async _toModel(resource: Model.PostgreSqlV2Sink, owner: Activity): Promise<PostgreSqlV2Sink> {
        const result = Owned.create<PostgreSqlV2Sink>(Metamodel.modelFor(PostgreSqlV2Sink), owner);
        TabularSinkAdapter.toSinkModel(resource, result);
        ValueAdapter.toModel(result, PostgreSqlV2Sink.WRITE_BEHAVIOR, resource.writeBehavior);
        return result;
    }
}
